module.exports = __webpack_public_path__ + "img/82.b0a1f3e4.jpg";